import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { getWorkspaces } from 'workspaces/api/getWorkspaces'

export const limit = 10

export const getWorkspacesQueryKey = (page) => ['getWorkspaces', page]

export const useGetWorkspaces = () => {
  const router = useRouter()

  const page = Number(router.query.page) || 1

  const { data } = useQuery({
    queryKey: getWorkspacesQueryKey(page),
    queryFn: () => getWorkspaces(page, limit)
  })

  return { items: data?.items || [], total: data?.total || 0, page, limit }
}
